var map = {
	"./vendor/spriteVideos/ENG_NarratorVideo/index.js": 6435,
	"./vendor/spriteVideos/ENG_SPS1-Basketball/index.js": 6436,
	"./vendor/spriteVideos/ENG_SPS10-Recess/index.js": 6437,
	"./vendor/spriteVideos/ENG_SPS2-FavoriteToy/index.js": 6438,
	"./vendor/spriteVideos/ENG_SPS3-NewFriends/index.js": 6439,
	"./vendor/spriteVideos/ENG_SPS4-Pants/index.js": 6440,
	"./vendor/spriteVideos/ENG_SPS5-FreeTime/index.js": 6441,
	"./vendor/spriteVideos/ENG_SPS6-HitByBalll/index.js": 6442,
	"./vendor/spriteVideos/ENG_SPS7-SpiltJuice/index.js": 6443,
	"./vendor/spriteVideos/ENG_SPS8-AfterSchool/index.js": 6444,
	"./vendor/spriteVideos/ENG_SPS9-ArtSupplies/index.js": 6445,
	"./vendor/spriteVideos/ENG_SPT1-Puppy_225002807/index.js": 6446,
	"./vendor/spriteVideos/ENG_SPT10-Soccer_225003020/index.js": 6447,
	"./vendor/spriteVideos/ENG_SPT11-Pool_225002889/index.js": 6448,
	"./vendor/spriteVideos/ENG_SPT12-ToyBox_225003055/index.js": 6449,
	"./vendor/spriteVideos/ENG_SPT2-Kites_225002840/index.js": 6450,
	"./vendor/spriteVideos/ENG_SPT3-Window_225003111/index.js": 6451,
	"./vendor/spriteVideos/ENG_SPT4-Trees_225002956/index.js": 6452,
	"./vendor/spriteVideos/ENG_SPT5-Birthday_225002526/index.js": 6453,
	"./vendor/spriteVideos/ENG_SPT6-Chores_225002643/index.js": 6454,
	"./vendor/spriteVideos/ENG_SPT7-Cookie_225002682/index.js": 6455,
	"./vendor/spriteVideos/ENG_SPT8-Doctor_225002747/index.js": 6456,
	"./vendor/spriteVideos/ENG_SPT9-Book_225002585/index.js": 6457,
	"./vendor/spriteVideos/EN_SPT10-Candy/index.js": 6458,
	"./vendor/spriteVideos/EN_SPT11-Book-Birthday/index.js": 6459,
	"./vendor/spriteVideos/EN_SPT12-Candy-Jar/index.js": 6460,
	"./vendor/spriteVideos/EN_SPT13-Game/index.js": 6461,
	"./vendor/spriteVideos/EN_SPT14-Homework/index.js": 6462,
	"./vendor/spriteVideos/EN_SPT15-Playground/index.js": 6463,
	"./vendor/spriteVideos/EN_SPT16-Costume-Box/index.js": 6464,
	"./vendor/spriteVideos/EN_SPT9-Broken-Window-Boy/index.js": 6465,
	"./vendor/spriteVideos/EN_TOM-Toybox/index.js": 6466,
	"./vendor/spriteVideos/ES_SPT10-Candy/index.js": 6467,
	"./vendor/spriteVideos/ES_SPT11-Book-Birthday/index.js": 6468,
	"./vendor/spriteVideos/ES_SPT12-Candy-Jar/index.js": 6469,
	"./vendor/spriteVideos/ES_SPT13-Game/index.js": 6470,
	"./vendor/spriteVideos/ES_SPT14-Homework/index.js": 6471,
	"./vendor/spriteVideos/ES_SPT15-Playground/index.js": 6472,
	"./vendor/spriteVideos/ES_SPT16-Costume-Box/index.js": 6473,
	"./vendor/spriteVideos/ES_SPT9-Broken-Window-Boy/index.js": 6474,
	"./vendor/spriteVideos/ES_TOM-Toybox/index.js": 6475,
	"./vendor/spriteVideos/SP_NarratorVideo/index.js": 6476,
	"./vendor/spriteVideos/SP_SPS1-Basketball/index.js": 6477,
	"./vendor/spriteVideos/SP_SPS10-Recess/index.js": 6478,
	"./vendor/spriteVideos/SP_SPS2-FavoriteToy/index.js": 6479,
	"./vendor/spriteVideos/SP_SPS3-NewFriends/index.js": 6480,
	"./vendor/spriteVideos/SP_SPS4-Pants/index.js": 6481,
	"./vendor/spriteVideos/SP_SPS5-Freetime/index.js": 6482,
	"./vendor/spriteVideos/SP_SPS6-HitByBall/index.js": 6483,
	"./vendor/spriteVideos/SP_SPS7-SpiltJuice/index.js": 6484,
	"./vendor/spriteVideos/SP_SPS8-AfterSchool/index.js": 6485,
	"./vendor/spriteVideos/SP_SPS9-ArtSupplies/index.js": 6486,
	"./vendor/spriteVideos/SP_SPT1-Puppy/index.js": 6487,
	"./vendor/spriteVideos/SP_SPT10-Soccer/index.js": 6488,
	"./vendor/spriteVideos/SP_SPT11-Pool/index.js": 6489,
	"./vendor/spriteVideos/SP_SPT12-ToyBox/index.js": 6490,
	"./vendor/spriteVideos/SP_SPT2-Kites/index.js": 6491,
	"./vendor/spriteVideos/SP_SPT3-Window/index.js": 6492,
	"./vendor/spriteVideos/SP_SPT4-Trees/index.js": 6493,
	"./vendor/spriteVideos/SP_SPT5-Birthday/index.js": 6494,
	"./vendor/spriteVideos/SP_SPT6-Chorese/index.js": 6495,
	"./vendor/spriteVideos/SP_SPT7-Cookie/index.js": 6496,
	"./vendor/spriteVideos/SP_SPT8-Doctor/index.js": 6497,
	"./vendor/spriteVideos/SP_SPT9-Book/index.js": 6498,
	"./vendor/spriteVideos/TEST_EN_spt_bookbirthday/index.js": 6499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4531;